import { 
    apiRequest,
    diklatList,
    diklatActive,
    diklatInactive,
    diklatHours,
    diklatApprove,
    masterRegion
 } from '../../../../../services/adapters/kepegawaian/diklatService'

class DiklatRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", diklatList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", diklatInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", diklatActive, {
            body: query
        }, true)
    }

    fetchHours = async (query, cancelToken) => {
        return await apiRequest("get", diklatHours, {
            cancelToken: cancelToken,
            params: query
        }, true);
    }

    fetchApprove = async (query) => {
        return await apiRequest("post", diklatApprove, {
            body: query
        }, true)
    }

    fetchRegion = async (query, cancelToken) => {
        return await apiRequest("get", masterRegion, {
            cancelToken: cancelToken,
            params: query
        }, true);
    }


    fetchRegionProvince = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionCity = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }


}

export default DiklatRepository
